import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // If already authenticated, redirect to home
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    // Get environment variables
    const oauthServerUrl = process.env.REACT_APP_OAUTH_SERVER_URL;
    const authEndpoint = process.env.REACT_APP_OAUTH_AUTH_ENDPOINT;
    const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_OAUTH_REDIRECT_URI;
    const scope = process.env.REACT_APP_OAUTH_SCOPE;

    // Debug environment variables
    console.log('OAuth Configuration:', {
      oauthServerUrl,
      authEndpoint,
      clientId,
      redirectUri,
      scope
    });

    // Validate required environment variables
    if (!oauthServerUrl || !authEndpoint || !clientId || !redirectUri || !scope) {
      console.error('Missing required OAuth configuration');
      return;
    }

    // Remove trailing slash from server URL if present
    const baseUrl = oauthServerUrl.endsWith('/') ? oauthServerUrl.slice(0, -1) : oauthServerUrl;
    // Remove leading slash from auth endpoint if present
    const endpoint = authEndpoint.startsWith('/') ? authEndpoint.slice(1) : authEndpoint;

    // Construct OAuth2 authorization URL
    const authUrl = new URL(`${baseUrl}/${endpoint}`);
    
    // Add required OAuth2 parameters
    const params = {
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: scope,
      state: Math.random().toString(36).substring(7) // Add state parameter for security
    };

    // Add parameters to URL
    Object.entries(params).forEach(([key, value]) => {
      authUrl.searchParams.append(key, value);
    });

    const finalUrl = authUrl.toString();
    console.log('Final OAuth URL:', finalUrl);

    // Use direct window.location.href for the redirect
    window.location.href = finalUrl;
  }, [isAuthenticated, navigate]);

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
            Redirecting to Login...
          </Typography>
          <CircularProgress />
        </Paper>
      </Box>
    </Container>
  );
};

export default Login; 